import {APIClient, AuthorizeInterceptor} from "@crunchyroll/cx-api-client-lite";

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} AccountAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} getAccount
 * @property {ApiMethod} getProfile
 * @property {ApiMethod} updateProfile
 * @property {ApiMethod} getUsernames
 * @property {ApiMethod} getNotificationSettings
 * @property {ApiMethod} updateNotificationSettings
 * @property {ApiMethod} updateCredentials
 * @property {ApiMethod} createEmailVerificationLink
 */
/**
 * @type {AccountAPIClient | APIClient}
 */
const Account = new APIClient({
  getAccount: {
    path: "/accounts/v1/me",
    method: "GET",
  },
  getProfile: {
    path: "/accounts/v1/me/profile",
    method: "GET",
  },
  updateProfile: {
    path: "/accounts/v1/me/profile",
    method: "PATCH",
    onSuccess: [AuthorizeInterceptor.authorize.bind(AuthorizeInterceptor)],
  },
  getUsernames: {
    path: "/accounts/v1/usernames",
    method: "GET",
  },
  getNotificationSettings: {
    path: "/accounts/v1/me/notification_settings",
    method: "GET",
  },
  updateNotificationSettings: {
    path: "/accounts/v1/me/notification_settings",
    method: "PATCH",
  },
  updateCredentials: {
    path: "/accounts/v1/me/credentials",
    method: "PATCH",
    onSuccess: [AuthorizeInterceptor.authorize.bind(AuthorizeInterceptor)],
  },
  createEmailVerificationLink: {
    path: "/accounts/v1/email_verification",
    method: "POST",
  },
  setEmail: {
    path: "/accounts/v1/phone/set_email",
    method: "POST",
  },
});

export default Account;
